import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  /**
   * Quick Find
   */
  quick_find_search_input_placeholder: {
    id: 'product_search_dialog.quick_find_search_input_placeholder',
    defaultMessage: 'Search or ask anything',
    description: 'A placeholder for the quick find search input'
  },
  quick_find_recent_search_text_dialog: {
    id: 'product_search_dialog.quick_find_recent_search_text_dialog',
    defaultMessage: 'From your recent searches',
    description: 'Recent search indicator text in search dialog box'
  },
  quick_find_show_organization_results: {
    id: 'product_search_dialog.quick_find_show_organization_results',
    defaultMessage: 'Search your organization',
    description: 'A label for a link that takes users to Full Page Search'
  },
  quick_find_show_filtered_results: {
    id: 'product_search_dialog.quick_find_show_filtered_results',
    defaultMessage: 'Filter by Confluence space, contributor and more',
    description: 'A label for a link that takes users to Full Page Search with a product filter applied'
  },
  quick_find_ask_atlassian_intelligence: {
    id: 'product_search_dialog.quick_find_ask_atlassian_intelligence',
    defaultMessage: 'Ask Atlassian Intelligence',
    description: 'A label for the link that takes users to an AI search'
  },
  quick_find_recently_viewed: {
    id: 'product_search_dialog.quick_find_recently_viewed',
    defaultMessage: 'Recently Viewed',
    description: 'Section title for recent content in Quick Find'
  },
  quick_find_recent_draft_label: {
    id: 'product_search_dialog.quick_find_recent_draft_label',
    defaultMessage: 'DRAFT',
    description: 'Lozenge label for draft results'
  },
  quick_find_recent_spaces_additional_meta: {
    id: 'product_search_dialog.quick_find_recent_spaces_additional_meta',
    defaultMessage: 'You recently visited',
    description: 'Additional meta for Quick Find recent spaces results'
  },
  quick_find_footer: {
    id: 'product_search_dialog.quick_find_footer',
    defaultMessage: 'Not getting the results you needed? <btn>Give feedback</btn>',
    description: 'Quick find footer text'
  },
  quick_find_footer_full_page_search_link: {
    id: 'product_search_dialog.quick_find_footer_full_page_search_link',
    defaultMessage: 'Search your organization',
    description: 'A label for a link that takes users to Full Page Search'
  },
  quick_find_no_content_header: {
    id: 'product_search_dialog.quick_find_no_content_header',
    defaultMessage: 'Seek and you shall find',
    description: 'Header of prompt to begin search journey if no recent content results are rendered'
  },
  quick_find_no_content_body: {
    id: 'product_search_dialog.quick_find_no_content_body',
    defaultMessage: "Search or ask for anything you're looking for in your Atlassian products",
    description: 'Body text of prompt to begin search journey if no recent content results are rendered'
  },
  quick_find_search_results: {
    id: 'product_search_dialog.quick_find_search_results',
    defaultMessage: 'Search Results',
    description: 'Section title for search results in Quick Find'
  },
  quick_find_confluence_space: {
    id: 'product_search_dialog.quick_find_confluence_space',
    defaultMessage: 'Confluence Space',
    description: 'Metadata for Confluence Space results'
  },
  quick_find_results_section: {
    id: 'product_search_dialog.quick_find_results_section',
    defaultMessage: 'Search Results',
    description: 'Section title for post query items in Quick Find'
  },
  quick_find_results_team: {
    id: 'product_search_dialog.quick_find_result_item_team',
    defaultMessage: 'Team',
    description: 'Label for team search results'
  }
});